import React from "react";

// components

import ReactTable from "../../components/Cards/ReactTable.js";

export default function Tables() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <ReactTable />
        </div>
        <div className="w-full mb-12 px-4">
          <ReactTable color="dark" />
        </div>
      </div>
    </>
  );
}
